import { List } from '../../List'
import { ListDivider } from '../../ListDivider'
import {
  EmptyListItem,
  LabelListItem,
  ListItem,
  LoaderListItem,
  RatingListItem,
  TextListItem,
  UserListItem,
} from '../../ListItem'
import { SelectDropdownAsyncListInitialLoader } from '../../Select'
import { StatusListItem } from '../../StatusListItem'
import { Container } from '../Container'

import * as styles from './Dropdowns.module.css'

function Dropdowns() {
  const src =
    'https://files.idwell.at/evilcorporation.qa.idwell.at/public/2022/09/2964c255-7c6f-46db-9f45-65d38dc7c93a.png'

  return (
    <>
      <Container label='Dropdown, empty'>
        <List className={styles.list300}>
          <EmptyListItem />
        </List>
      </Container>
      <Container label='Dropdown, initiating'>
        <List className={styles.list300}>
          <SelectDropdownAsyncListInitialLoader
            hasText
            className={styles.initialLoader}
          />
        </List>
      </Container>
      <Container label='Dropdown, basic'>
        <List className={styles.list300}>
          <TextListItem text='Option 1' />
          <TextListItem text='Option 2' />
          <TextListItem text='Option 3 Option 3 Option 3 Option 3 Option 3 Option 3' />
        </List>
      </Container>
      <Container label='Dropdown, basic, with loader'>
        <List className={styles.list300}>
          <TextListItem text='Option 1' />
          <TextListItem text='Option 2' />
          <TextListItem text='Option 3' />
          <LoaderListItem hasText />
        </List>
      </Container>
      <Container label='Dropdown, basic, with scroll(default max height 352)'>
        <List className={styles.list300}>
          <TextListItem text='Option 1' />
          <TextListItem text='Option 2' />
          <TextListItem text='Option 3' />
          <TextListItem text='Option 4' />
          <TextListItem text='Option 5' />
          <TextListItem text='Option 6' />
          <TextListItem text='Option 7' />
          <TextListItem text='Option 8' />
          <TextListItem text='Option 9' />
        </List>
      </Container>
      <Container label='Dropdown, basic, with divider, with active item'>
        <List className={styles.list300}>
          <div>
            <ListItem text='First item' />
            <ListItem isActive text='Second item, active' />
          </div>
          <ListDivider />
          <div>
            <ListItem text='Third item' />
          </div>
        </List>
      </Container>
      <Container label='Dropdown, basic, with checkbox'>
        <List className={styles.list300}>
          <TextListItem isMulti text='Option 1' />
          <TextListItem isMulti text='Option 2' />
          <TextListItem
            isMulti
            text='Option 3 Option 3 Option 3 Option 3 Option 3 Option 3'
          />
        </List>
      </Container>
      <Container label='Dropdown, user type, with checkbox'>
        <List className={styles.list300}>
          <UserListItem
            isMulti
            value={{
              label: {
                avatar: src,
                email: 'admin@user.com',
                fullname: 'User',
                role: 'admin',
              },
              value: 1,
            }}
          />
          <UserListItem
            isMulti
            value={{
              label: {
                avatar_color: '#B7AC22',
                email: 'dweller@user.com',
                fullname: 'User',
                role: 'dweller',
              },
              value: 2,
            }}
          />
          <UserListItem
            isMulti
            value={{
              label: {
                avatar_color: '#1FF7D1',
                email:
                  'manager@user.com manager@user.com manager@user.com manager@user.com manager@user.com',
                fullname:
                  'Manager Manager Manager Manager Manager Manager Manager Manager',
                role: 'manager',
              },
              value: 3,
            }}
          />
        </List>
      </Container>
      <Container label='Dropdown, user type, with checkbox, with label'>
        <List className={styles.list300}>
          <UserListItem
            isMulti
            value={{
              label: {
                avatar: src,
                fullname: 'User',
                role: 'admin',
                status: 0,
              },
              value: 1,
            }}
          />
          <UserListItem
            isMulti
            value={{
              label: {
                avatar: src,
                fullname: 'User',
                role: 'admin',
                status: 1,
              },
              value: 2,
            }}
          />
          <UserListItem
            isMulti
            value={{
              label: {
                avatar_color: '#36C857',
                fullname: 'User',
                role: 'dweller',
                status: 2,
              },
              value: 3,
            }}
          />
          <UserListItem
            isMulti
            value={{
              label: {
                avatar_color: '#E76124',
                fullname: 'Manager',
                role: 'manager',
                status: 3,
              },
              value: 4,
            }}
          />
          <UserListItem
            isMulti
            value={{
              label: {
                avatar_color: '#462721',
                fullname: 'Manager',
                role: 'manager',
                status: 4,
              },
              value: 5,
            }}
          />
        </List>
      </Container>
      <Container label='Dropdown, rating type, with checkbox'>
        <List className={styles.list300}>
          <TextListItem isMulti text='No rating' />
          <RatingListItem isMulti value={{ label: 1, value: 1 }} />
          <RatingListItem isMulti value={{ label: 2, value: 2 }} />
          <RatingListItem isMulti value={{ label: 3, value: 3 }} />
          <RatingListItem isMulti value={{ label: 4, value: 4 }} />
          <RatingListItem isMulti value={{ label: 5, value: 5 }} />
        </List>
      </Container>
      <Container label='Dropdown, label type, with checkbox'>
        <List className={styles.list300}>
          <LabelListItem
            isMulti
            value={{
              label: { color: '#A0B95C', title: 'Installer' },
              value: 1,
            }}
          />
          <LabelListItem
            isMulti
            value={{
              label: { color: '#6A6571', title: 'Imported by assfinet' },
              value: 2,
            }}
          />
          <LabelListItem
            isMulti
            value={{
              label: { color: '#F15BB5', title: 'Landlord' },
              value: 3,
            }}
          />
        </List>
      </Container>
      <Container label='Dropdown, status type, with checkbox'>
        <List className={styles.list300}>
          <StatusListItem isMulti status={1} />
          <StatusListItem isMulti status={2} />
          <StatusListItem isMulti status={3} />
          <StatusListItem isMulti status={4} />
        </List>
      </Container>
    </>
  )
}

export default Dropdowns
